import React, { useState } from 'react';
import ModalSearch from './ModalSearch';
import SearchIcon from '@/images/icons/Search';

const Search = () => {
	const [searchModalOpen, setSearchModalOpen] = useState(false);

	return (
		<>
			<button
				className="min-w-7 sm:min-w-8 w-7 sm:w-8 h-7 sm:h-8 flex items-center justify-center bg-[#F7F6F2] text-brand-green transition rounded-full ml-4"
				onClick={(e) => { e.stopPropagation(); setSearchModalOpen(true); }}
				aria-controls="search-modal"
			>
				<span className="sr-only">Search</span>
				<SearchIcon className="w-3.5 h-3.5" />
			</button>
			<ModalSearch id="search-modal" searchId="search" modalOpen={searchModalOpen} setModalOpen={setSearchModalOpen} placeholder="Search" />
		</>
	)
}

export default Search;
